module.exports = __webpack_public_path__ + "static/media/goodbricks-logo-white.ac894fb3.svg";